import { render } from "./wage-employee-admin.vue?vue&type=template&id=1b9e8472"
import script from "./wage-employee-admin.vue?vue&type=script&lang=js"
export * from "./wage-employee-admin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-employee-admin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b9e8472"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b9e8472', __exports__)) {
    api.reload('1b9e8472', __exports__)
  }
  
  module.hot.accept("./wage-employee-admin.vue?vue&type=template&id=1b9e8472", () => {
    api.rerender('1b9e8472', render)
  })

}


export default __exports__